import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'

//components
import {PaperworkOnlyMoveLineItemGridComponent} from '../../components/Grids/PaperworkOnlyMoveLineItemGrid.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-paperworkonlymovedetails',
  templateUrl: './PaperworkOnlyMoveDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => PaperworkOnlyMoveDetailsComponent)}]
})
export class PaperworkOnlyMoveDetailsComponent extends BaseControlGroupComponent {
    
    

    @ViewChild(PaperworkOnlyMoveLineItemGridComponent) public paperworkOnlyMoveLineItemGridComponent: PaperworkOnlyMoveLineItemGridComponent;
    

    setRequestInfo(request: ent.Request){
        this.paperworkOnlyMoveLineItemGridComponent.lineItems = request.PaperworkOnlyMoveLineItems;
    }

    public setDates(): void {
        
    }


    constructor() 
    { 
        super();
    }

    ngOnInit(): void {
        
    }


    onLineItemsChanged(event: number){
       
    }

}
